<template>
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <!-- Logo -->
      <div class="mb-8 image-logo p-5 bg-white ">
      <img src="@/assets/logohp.png" alt="Logo" class=" h-auto mx-auto" />
    </div>
      <!-- Contenedor del formulario -->
      <div class="w-full max-w-md bg-white p-6 rounded-lg shadow-md">
        <h1 class="text-2xl font-bold mb-6 text-center">Crear cuenta</h1>
  
        <form @submit.prevent="handleRegister">
          <!-- Campo de Nombre -->
          <div class="mb-6">
            <label for="nombre" class="block text-gray-700 font-medium mb-2">Tu nombre</label>
            <input
              v-model="nombre"
              type="text"
              id="nombre"
              placeholder="Nombre y apellido"
              class="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
              required
            />
          </div>
  
          <!-- Campo de Email -->
          <div class="mb-6">
            <label for="email" class="block text-gray-700 font-medium mb-2">Dirección de email</label>
            <input
              v-model="email"
              type="email"
              id="email"
              placeholder="ejemplo@mail.com"
              class="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
              required
            />
          </div>
  
          <!-- Campo de Contraseña -->
          <div class="mb-6">
            <label for="password" class="block text-gray-700 font-medium mb-2">Contraseña</label>
            <input
              v-model="password"
              type="password"
              id="password"
              placeholder="Debe tener al menos 7 caracteres"
              class="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
              required
            />
          </div>
  
          <!-- Confirmar Contraseña -->
          <div class="mb-6">
            <label for="confirmPassword" class="block text-gray-700 font-medium mb-2">Confirmar contraseña</label>
            <input
              v-model="confirmPassword"
              type="password"
              id="confirmPassword"
              placeholder="Repite tu contraseña"
              class="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
              required
            />
          </div>
  
          <!-- Clave de Autorización -->
          <div class="mb-6">
            <label for="clave" class="block text-gray-700 font-medium mb-2">Clave de autorización</label>
            <input
              v-model="clave"
              type="text"
              id="clave"
              placeholder="Ingresa la clave de autorización"
              class="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring focus:ring-blue-500 uppercase"
              required
            />
          </div>
  
          <!-- Botón de Registro -->
          <button
            type="submit"
            class="w-full bg-blue-500 text-white font-medium py-3 rounded-lg hover:bg-blue-600 transition"
          >
            Continuar
          </button>
        </form>
  
        <!-- Términos y condiciones -->
        <div class="text-center mt-4">
          <p class="text-gray-600 text-sm">
            Al crear una cuenta aceptas las
            <a href="/condiciones-de-uso" class="text-blue-500 hover:underline">Condiciones de Uso</a>
            y el
            <a href="/aviso-de-privacidad" class="text-blue-500 hover:underline">Aviso de privacidad</a>.
          </p>
        </div>
      </div>
  
      <!-- Caja para iniciar sesión -->
      <div class="w-full max-w-md bg-gray-50 p-6 mt-6 rounded-lg shadow-md text-center">
        <p class="text-lg font-medium mb-4">¿Ya tienes una cuenta?</p>
        <button
          @click="goToLogin"
          class="w-full bg-gray-500 text-white font-medium py-3 rounded-lg hover:bg-gray-600 transition"
        >
          Iniciar sesión
        </button>
      </div>
    </div>
  </template>
  
  ---
  
  <!-- ### **Script**
  ```javascript -->
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        email: "",
        password: "",
        confirmPassword: "",
        nombre: "",
        clave: "",
      };
    },
    methods: {
      handleRegister() {
        // Validar contraseñas
        if (this.password !== this.confirmPassword) {
          alert("Las contraseñas no coinciden.");
          return;
        }
  
        // Validar clave
        if (!this.clave) {
          alert("La clave de autorización es obligatoria.");
          return;
        }
  
        // Enviar datos al servidor
        axios
          .post("/api/register", {
            email: this.email,
            password: this.password,
            nombre: this.nombre,
            clave: this.clave,
          })
          .then((response) => {
            if (response.data.success) {
              alert("Registro exitoso. Ahora puedes iniciar sesión.");
              this.goToLogin();
            } else {
              alert(response.data.error);
            }
          })
          .catch((error) => {
            console.error("Error en el registro:", error);
            alert("Ocurrió un problema. Por favor, intenta de nuevo.");
          });
      },
      goToLogin() {
        this.$router.push("/login");
      },
    },
  };
  </script>
  